import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IResponseCodeFormMeta {
  // Response Code
  acquirerResponseCode: FormInputMeta;
  responseAction: FormInputMeta;
  issuerResponseCode: FormInputMeta;
  responseCode: FormInputMeta;
  hsmResponseCode: FormInputMeta;
  additionalResponseCode: FormInputMeta;
  cvvVerificationResponse: FormInputMeta;
  rejectOrDeclineReason: FormInputMeta;
  // Additional Response Code
  stipSwitchReasonCode: FormInputMeta;
  dynamicStandinFlagSystemMalfunction: FormInputMeta;
  dynamicStandinCapability: FormInputMeta;
  dynamicStandinFlagTimeOut: FormInputMeta;
  controlResult: FormInputMeta;
  onlineOfflineWithIssuer: FormInputMeta;
  // CPS Data
  authorizationCharacteristics: FormInputMeta;
  transactionIdentifier : FormInputMeta;
  validationCode: FormInputMeta;
  // Network Data
  bankData: FormInputMeta;
  networkId : FormInputMeta;
  messageReasonCode: FormInputMeta;
  // Others
  functionCode: FormInputMeta;
  pinCaptureCode: FormInputMeta;
  authorizationNumber: FormInputMeta;


  schema: any;
}

const ResponseCodeFormMeta = {} as IResponseCodeFormMeta;
// Response Code
ResponseCodeFormMeta.acquirerResponseCode = {
  name: 'acquirerResponseCode',
  type: 'text',
  label: 'Code de réponse de l\'acquéreur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
ResponseCodeFormMeta.responseAction = {
  name: 'responseAction',
  type: 'text',
  label: 'Réponse Action',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
ResponseCodeFormMeta.issuerResponseCode = {
  name: 'issuerResponseCode',
  type: 'text',
  label: 'Emetteur Code de réponse',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
ResponseCodeFormMeta.responseCode = {
  name: 'responseCode',
  type: 'text',
  label: 'Code de réponse',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
ResponseCodeFormMeta.hsmResponseCode = {
  name: 'hsmResponseCode',
  type: 'text',
  label: 'Code de réponse HSM',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
ResponseCodeFormMeta.additionalResponseCode = {
  name: 'additionalResponseCode',
  type: 'text',
  label: 'Additional Response Code',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.cvvVerificationResponse = {
  name: 'cvvVerificationResponse',
  type: 'text',
  label: 'Réponse de vérification cvv',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
ResponseCodeFormMeta.rejectOrDeclineReason = {
  name: 'rejectOrDeclineReason',
  type: 'text',
  label: 'Motif de rejet ou de refus',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

 // Additional Response Code
ResponseCodeFormMeta.stipSwitchReasonCode = {
  name: 'stipSwitchReasonCode',
  type: 'text',
  label: 'Stip Switch Reason Code',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.dynamicStandinFlagSystemMalfunction = {
  name: 'dynamicStandinFlagSystemMalfunction',
  type: 'text',
  label: 'Drapeau dynamique du standin Dysfonctionnement du système',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.dynamicStandinCapability = {
  name: 'dynamicStandinCapability',
  type: 'text',
  label: 'Capacité de mise en attente dynamique',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.dynamicStandinFlagTimeOut = {
  name: 'dynamicStandinFlagTimeOut',
  type: 'text',
  label: 'Indicateur d\'attente dynamique Délai d\'attente',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.controlResult = {
  name: 'controlResult',
  type: 'text',
  label: 'Résultat du contrôle',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.onlineOfflineWithIssuer = {
  name: 'onlineOfflineWithIssuer',
  type: 'text',
  label: 'En ligne/hors ligne avec l\'émetteur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// CPS Data
ResponseCodeFormMeta.authorizationCharacteristics = {
  name: 'authorizationCharacteristics',
  type: 'text',
  label: 'Caractéristiques de l\'autorisation',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.transactionIdentifier = {
  name: 'transactionIdentifier',
  type: 'text',
  label: 'Identifiant de la transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.validationCode = {
  name: 'validationCode',
  type: 'text',
  label: 'Code de validation',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Network Data
ResponseCodeFormMeta.bankData = {
  name: 'bankData',
  type: 'text',
  label: 'Données bancaires',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.networkId = {
  name: 'networkId',
  type: 'text',
  label: 'Id réseau',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.messageReasonCode = {
  name: 'messageReasonCode',
  type: 'text',
  label: 'Message Code de raison',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Others 
ResponseCodeFormMeta.functionCode = {
  name: 'functionCode',
  type: 'text',
  label: 'Code de fonction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.pinCaptureCode = {
  name: 'pinCaptureCode',
  type: 'text',
  label: 'Code de capture du PIN',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
ResponseCodeFormMeta.authorizationNumber = {
  name: 'authorizationNumber',
  type: 'text',
  label: 'Numéro d\'autorisation',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}


ResponseCodeFormMeta.schema = yup.object().shape(getValidationSchema(ResponseCodeFormMeta));

export default ResponseCodeFormMeta;